import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth.component';
import { forgotComponent } from './forgot.component';

const routes: Routes = [
    { path: '', component: AuthComponent },
    // { path: 'forgot', component: forgotComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {
}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/auth/auth-routing.routing.ts